// TODO: Move this JS file to Webpack folder since it is now only consumed by
// Webpacker-compiled applications
import 'angular';
import { select, selectAll } from 'd3-selection';
import { scaleLinear, scaleBand } from 'd3-scale';
import { axisLeft, axisBottom } from 'd3-axis';
import '../../../services/chart.service';
import '../common/chart-label';
import '../common/chart-legend';
import '../common/empty-results';

angular.module('directives.visualizations.barChart', ['services.ChartService'])
  .directive('barChart', [
    'ChartService',
    function(Chart) {
      return {
        restrict: 'E',
        scope: {
          items: '=',
          filteredBy: '=',
          showAlertInfo: '=',
          emptyMessage: '=?',
          onClickCallback: '=',
          colorRange: '<'
        },

        template:
          '<empty-results ng-hide="items.length" message="emptyMessage"></empty-results>' +
          '<div class="row">' +
            '<div class="col-sm-8">' +
              '<div class="chart">' +
                '<chart-label position="label.position" visibility="label.visible" key="label.key" value="label.value" arrow="label.arrow"></chart-label>' +
                '<svg></svg>' +
              '</div>' +
            '</div>' +
            '<div class="col-sm-4">' +
              '<chart-legend mouseover="mouseover" mouseout="mouseout" click="onClickCallback" data="items" color="color"></chart-legend>' +
            '</div>' +
          '</div>' +
          '<div ng-if="showAlertInfo" ng-show="filteredBy.getValue().length && items.length" class="small padding-medium alert alert-info">' +
            'This chart displays funding going to' +
            '<span ng-repeat="place in filteredBy.getValue()">{{ $first ? \'\' : $last ? \' and \' : \', \' }}<strong>{{place}}</strong></span>' +
            'and multi-country funding opportunities going to' +
            '<span ng-repeat="place in filteredBy.getValue()">{{$first ? \'\' : $last ? \' and \' : \', \'}}{{place}}</span>' +
            'as well as other locations.' +
          '</div>',

        link: function (scope, element) {
          // Container (to get the SVG tag and the size to center the chart)
          var container = element[0].querySelector('.chart');
          // SVG element, used to clean the chart
          var target = container.querySelector('svg');
          // D3 element, used to draw the chart and find bars
          var svg = select(target);
          // Radius of the pie chart
          var barSize;
          // Processed data (min, max, total, sorted)
          var data;
          // Left offset
          var left = 40;
          // Top offset
          var top = 20;

          scope.label = {
            arrow: true,
            position: {}
          };

          /**
           * Function to be executed on mouseover events, it adds a border to
           * the specified bar (rect),  applies a class to the legend and
           * fills the label object (and displays it)
           *
           * @param {string} key - Bar/Legend value key
           * @returns {undefined}
           */
          scope.mouseover = function(key) {
            var bar = svg.select('[data-id="' + key + '"]');
            // Bar binded data
            var datum = bar.datum();

            // Bar border
            bar.classed('active', true);

            // Legend highlight
            selectAll('.chart-legend [data-id="' + key + '"]')
              .classed('active', true);

            // Label properties
            var y = parseFloat(bar.attr('y')) + top / 2;
            var x = parseFloat(bar.attr('x')) + left + barSize / 2;

            scope.label.visible = true;
            scope.label.key = datum.key;
            scope.label.value = devex.util.numberWithCommas(datum.value) + ' (' +
                                (datum.value / data.total * 100).toFixed(1) + '%)';
            scope.label.position.top = y;
            scope.label.position.left = x;
          };

          /**
           * Function to be executed on mouseout events, it removes the border
           * of the specified bar (rect), removes a class of the legend and
           * hides the label
           *
           * @param {string} key - Bar/Legend value key
           * @returns {undefined}
           */
          scope.mouseout = function(key) {
            // Bar border
            svg.select('[data-id="' + key + '"]').classed('active', false);

            // Legend highlight
            selectAll('.chart-legend [data-id="' + key + '"]')
              .classed('active', false);

            // Label properties
            scope.label.visible = false;
          };

          var render = function() {
            // First we erase the content rendered on the SVG element
            Chart.erase(target);

            /**
             * DATA
             */
            data = Chart.getData(scope.items);

            /**
             * SIZE
             */
            var size = Chart.getSize(container);
            var width = size.width - 45;
            var height = size.height - 30; // extra height for the legend

            /**
             * STYLING
             */
            scope.color = scaleLinear()
              .domain([data.min, data.max])
              .range(scope.colorRange ? scope.colorRange : ['#FFDD88', '#FF9900']);

            /**
             * CHART
             */
            var chart = svg.append('g')
              .attr('class', 'bars')
              .attr('transform', 'translate(' + left + ', ' + top + ')');

            /**
             * AXIS
             */
            var x = scaleBand()
              .rangeRound([0, width])
              .domain(data.value_sorted.map(function(d) { return d.key; }))
              .padding(0.4);
            var y = scaleLinear()
              .rangeRound([height, 0])
              .domain([0, data.max / data.total + 0.02]);

            chart.append('g')
              .attr('class', 'axis')
              .attr('transform', 'translate(0,' + height + ')')
              .call(axisBottom(x).tickValues([]));

            chart.append('g')
              .attr('class', 'axis')
              .call(axisLeft(y).ticks(5, '%'));

            chart.append('text')
              .attr('class', 'units')
              .attr('x', 20)
              .attr('y', -10)
              .attr('text-anchor', 'end')
              .text('Frequency');

            /**
             * HORIZONTAL GRIDLINES
             */
            chart.append('g')
              .attr('class', 'grid')
              .call(axisLeft(y).ticks(5, '').tickSize(-width).tickFormat(''));

            /**
             * BARS
             */
            barSize = x.bandwidth();

            chart.selectAll('.bar')
              .data(data.value_sorted)
              .enter()
              .append('rect')
              .attr('fill', function(d) {
                return scope.color(d.value);
              })
              .attr('class', 'bar')
              .attr('data-id', function(d) {
                return d.key;
              })
              .attr('x', function(d) {
                return x(d.key);
              })
              .attr('y', function(d) {
                return y(d.value / data.total).toFixed(1);
              })
              .attr('width', barSize)
              .attr('height', function(d) {
                return height - y(d.value / data.total);
              })
              .on('mouseover', function(_, d) {
                scope.$apply(function() {
                  scope.mouseover(d.key);
                });
              })
              .on('mouseout', function(_, d) {
                scope.$apply(function() {
                  scope.mouseout(d.key);
                });
              })
              .on('click', function(_, d) {
                scope.$apply(function() {
                  if (scope.onClickCallback){
                    scope.onClickCallback(d.key);
                  }
                });
              });
          };

          var renderWithData = function() {
            if(scope.items && scope.items.length) {
              render();
            }
          };

          renderWithData();

          scope.$watch('items', renderWithData);

          window.addEventListener('resize', renderWithData);

          scope.$on('$destroy', function() {
            window.removeEventListener('resize', renderWithData);
          });
        }
      };
    }
  ]);
